<template>
  <div>
    <Counting_stock_check/>
  </div>
</template>

<script>
import Counting_stock_check from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_check";
export default {
  name: "Countingstockcheck",
  components: {
    Counting_stock_check
  }
}
</script>

<style scoped>

</style>
